/* eslint-disable import/no-extraneous-dependencies */
// Polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'fetch-ie8';
/* eslint-enable import/no-extraneous-dependencies */
